import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ShapesOfflineIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ShapesOfflineIcon = ({ className, ...props }: ShapesOfflineIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.4 15.2c.582 0 .873 0 .96-.02.39-.086.511-.205.604-.595.02-.086.023-.254.027-.592C20 13.394 20 12.733 20 12c0-.96 0-1.797-.02-2.531-.01-.394-.386-.669-.78-.669A3.2 3.2 0 0 1 16 5.6c0-.574 0-.86-.026-.96-.089-.341-.206-.463-.545-.564-.098-.03-.261-.035-.588-.047C14.035 4 13.097 4 12 4c-.733 0-1.394 0-1.993.009-.338.004-.506.007-.592.027-.39.093-.509.213-.596.605-.019.086-.019.377-.019.959M15.2 18.4c0 .582 0 .873-.02.96-.086.39-.205.511-.595.604-.086.02-.254.023-.592.027C13.394 20 12.733 20 12 20s-1.394 0-1.993-.009c-.338-.004-.506-.007-.592-.027-.39-.093-.509-.213-.596-.605-.019-.086-.019-.377-.019-.959a3.2 3.2 0 0 0-3.2-3.2c-.582 0-.873 0-.96-.02-.39-.086-.511-.205-.604-.595-.02-.086-.023-.254-.027-.592C4 13.394 4 12.733 4 12s0-1.394.009-1.993c.004-.338.007-.506.027-.592.093-.39.213-.509.605-.596.086-.019.377-.019.959-.019"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="m4 4 16 16"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
  
export default ShapesOfflineIcon;